import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { BsPerson } from "react-icons/bs";
import { BsEyeSlash } from "react-icons/bs";
import { BsEye } from "react-icons/bs";
import { HiOutlineQrCode } from "react-icons/hi2";





import Blocked from '../Blocked/Blocked';

const SignInform = props => {
    const [passwordIsVisible, setPasswordIsVisible] = useState(false);

    return (
        <Form onSubmit={props.loginHandler} render={({ handleSubmit, submitting, pristine, values }) => (
            <form onSubmit={!props.userIsBlocked ? handleSubmit : event => event.preventDefault()} autoComplete="false">
                <div id="loginForm">
                    <div className="form-group form-material floating" data-plugin="formMaterial">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><BsPerson size={17} /></span>
                            </div>
                            <div className="form-control-wrap">
                                <Field type="text" name="username" className="form-control empty" component="input" required />
                                <label className="floating-label">Username or email</label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-material floating" data-plugin="formMaterial">
                        <div className="input-group">
                            <div className="input-group-prepend" onClick={() => setPasswordIsVisible(!passwordIsVisible)} style={{ cursor: 'pointer' }}>
                                <span className="input-group-text">{!passwordIsVisible ? <BsEyeSlash size={16} /> : <BsEye size={16} />}</span>
                            </div>
                            <div className="form-control-wrap">
                                <Field type={!passwordIsVisible ? 'password' : 'text'} name="password" className="form-control empty" component="input" required />
                                <label className="floating-label">Password</label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group form-material floating" data-plugin="formMaterial">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><HiOutlineQrCode size={17}/></span>
                            </div>
                            <div className="form-control-wrap">
                                <Field type="text" name="code" className="form-control empty" component="input" required />
                                <label className="floating-label">Code</label>
                            </div>
                        </div>
                    </div>
                    <div className="form-group clearfix">
                        <div className="checkbox-custom checkbox-inline checkbox-primary float-left">
                            <input type="checkbox" id="remember" name="checkbox" />
                            <label htmlFor="remember">Remember me</label>
                        </div>
                        <a className="float-right" href='/forgot-password'>Forgot password?</a>
                    </div>
                </div>
                <div className="form-group">
                    {props.userIsBlocked && <Blocked />}
                    {!props.userIsBlocked && (
                        <button type="submit" className="btn btn-block btn-sm btn-raised btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic" disabled={submitting || pristine}>
                            <span><i className="icon ti-unlock" aria-hidden="true"></i>&nbsp;Sign In</span>
                        </button>
                    )}
                </div>
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </form>
        )} />
    );
};

const mapStateToProps = state => {
    return {
        userIsBlocked: state.auth.userIsBlocked
    };
};

SignInform.propTypes = {
    loginHandler: propTypes.func,
    userIsBlocked: propTypes.bool
};

export default connect(mapStateToProps)(SignInform);